import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootEl = document.getElementById('root');
ReactDOM.createRoot(rootEl).render(<App />);

// Sinaliza para o watchdog do index.html que o React montou.
rootEl?.setAttribute('data-app-ready', '1');

/**
 * PWA: evita tela branca apos longo idle / troca de service worker.
 *
 * 1) controllerchange — novo SW assumiu (deploy). Sem reload, a pagina antiga
 *    pede JS com hash velho → 404 → tela branca.
 * 2) visibilitychange — app voltou do background. Se o SO matou o processo e
 *    o shell ficou sem React (root vazio), recarrega.
 * 3) pageshow (bfcache) — iOS/Safari às vezes restaura pagina morta.
 */
if ('serviceWorker' in navigator) {
  let refreshing = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}

function precisaRecarregar() {
  const root = document.getElementById('root');
  if (!root) return true;
  // React montou e ainda tem filhos → ok
  if (root.getAttribute('data-app-ready') === '1' && root.childElementCount > 0) {
    return false;
  }
  // Root vazio / sem marca de mount = shell morto
  return root.childElementCount === 0;
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState !== 'visible') return;
  if (precisaRecarregar()) {
    window.location.reload();
  }
});

window.addEventListener('pageshow', (event) => {
  // Restaurado do bfcache com estado inconsistente
  if (event.persisted && precisaRecarregar()) {
    window.location.reload();
  }
});
